<template>
  <div
    class="default-title-wrapper"
    :style="{
      borderColor: theme,
      width: width ? `${width}px` : '',
      'text-align': width ? 'right' : 'left',
    }"
  >
    <span
      class="title"
      :style="{
        color: theme,
        'max-width': cvDetail.format_info.top_format === 'left_form' ? '112px' : '',
      }"
    >{{ name }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['name', 'theme', 'width'],
  computed: {
    ...mapState('editor', ['cvDetail'])
  }
}
</script>

<style lang="scss" scoped>
  .default-title-wrapper {
    border-bottom: 1px solid #404040;
    margin-bottom: 8px;
  }
  .title {
    display: inline-block;
    color: #404040;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
    width: max-content;
  }
</style>
